import { CdkConnectedOverlay, Overlay } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { cueNavigationCircle, IconComponent } from '@cue/ui/icons';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'cue-planning-path',
  imports: [CdkConnectedOverlay, IconComponent, TranslocoPipe],
  templateUrl: './planning-path.component.html',
  styleUrl: './planning-path.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanningPathComponent {
  private readonly overlay = inject(Overlay);

  ICONS = {
    cueNavigationCircle,
  };

  protected readonly positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();
  protected readonly translation = translation;
}
